import React from 'react';

import { formatDate } from 'Helpers/dateUtils';

import TableRowSkeleton from 'CommonComponents/TableRowSkeleton';
import Tooltip from 'CommonComponents/Tooltip';

import ArrowUturnLeftIcon from 'Assets/icons/arrow-uturn-left.svg';
import TrashIcon from 'Assets/icons/trash.svg';

export default function TrashedGeneralRisksTable({ isLoading, risks, onRestore, onForceDelete }) {
    return (
        <div className="inbud-table_wrapper">
            <div className="tw-overflow-y-auto tw-max-h-[40vh]">
                <table className="inbud-table tw-table-fixed">
                    <thead>
                        <tr>
                            <th className="tw-sticky tw-top-0 tw-w-32">{$t('Reference')}</th>
                            <th className="tw-sticky tw-top-0 tw-w-96">{$t('Description')}</th>
                            <th className="tw-sticky tw-top-0 tw-w-48">{$t('Deleted By')}</th>
                            <th className="tw-sticky tw-top-0 tw-w-48">{$t('Deleted At')}</th>
                            <th className="tw-sticky tw-top-0 tw-w-32">{$t('Actions')}</th>
                        </tr>
                    </thead>
                    {!isLoading && !!risks?.length && (
                        <tbody>
                            {risks.map((risk) => (
                                <tr key={risk.id}>
                                    <td>{risk.id}</td>
                                    <td>
                                        <Tooltip placement="auto" tooltipContent={risk.detailed_description || '-'} tooltipType="text">
                                            <div className="tw-text-blue">{risk.description}</div>
                                        </Tooltip>
                                    </td>
                                    <td>{risk.deleted_by_user ? `${risk.deleted_by_user.first_name} ${risk.deleted_by_user.last_name}` : '-'}</td>
                                    <td>{risk.deleted_at ? formatDate(risk.deleted_at) : '-'}</td>
                                    <td>
                                        <div className="tw-flex tw-items-center tw-gap-x-3">
                                            <Tooltip placement="top" tooltipContent={$t('Restore')} tooltipType="text">
                                                <button type="button" className="tw-text-green" onClick={() => onRestore(risk)}>
                                                    <ArrowUturnLeftIcon className="tw-w-3 tw-h-3" />
                                                </button>
                                            </Tooltip>
                                            <Tooltip placement="top" tooltipContent={$t('Permanently Delete')} tooltipType="text">
                                                <button type="button" className="tw-text-red" onClick={() => onForceDelete(risk)}>
                                                    <TrashIcon className="tw-w-3 tw-h-3" />
                                                </button>
                                            </Tooltip>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    )}
                    {isLoading && (
                        <tbody>
                            <TableRowSkeleton rows={3} columns={5} />
                        </tbody>
                    )}
                    {!isLoading && !risks?.length && (
                        <tbody>
                            <tr>
                                <td colSpan={5}>
                                    <span className="tw-italic">{$t('No deleted risks found')}</span>
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </div>
    );
}
